import * as yup from "yup";

export const profileInfoSchema = yup.object().shape({
  first_name: yup.string().trim().required("First name is required"),
  last_name: yup.string().trim().required("Last name is required"),
  email: yup.string().email().required("Email address is required"),
  phone: yup.string().length(10, "Invalid phone number").required("Phone number is required"),
});
export const emailVerificationSchema = yup.object().shape({
  verification_code: yup
    .string()
    .trim()
    .required("Verification Code is required")
    .min(4, "Please enter at least 4 characters.")
    .max(4, "Please enter no more than 4 characters."),
});
